export function componentDidMount() {
  const { handleOutsideClick } = this.props;
  document.addEventListener('mousedown', handleOutsideClick, false);
}

export function componentWillUnmount() {
  document.removeEventListener('mousedown', this.props.handleOutsideClick, false);
}
